import {createElement, Component, PropTypes} from 'rlink-react';
import TextContentInput from './TextContentInput';


export default class StringInput extends TextContentInput {
  constructor (props, context) {
    super(props, context);
    this.attributes = {
      minLength: this.minLength,
      maxLength: this.maxLength,
      placeholder: this.placeholder,
      autoComplete: this.autoComplete,
    };
  }

  get minLength () {
    return this.fromPropsOrContext('minLength');
  }

  get maxLength () {
    return this.fromPropsOrContext('maxLength');
  }

  get placeholder () {
    return this.fromPropsOrContext('placeholder');
  }

  get autoComplete () {
    return this.fromPropsOrContext('autoComplete');
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/StringInput.jsx